// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__02Q7Q","spin":"Loader_spin__vQSSt","sm":"Loader_sm__-2Tb0","md":"Loader_md__NIPfv","lg":"Loader_lg__GhTu9"};